import Vue from 'vue'
import 'amfe-flexible';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import ElementUI from 'element-ui';
import animate from 'animate.css'
Vue.use(animate)
import router from './vue-router/index'
import axios from 'axios'
import Banner from './components/layout/banner'

axios.defaults.withCredentials = true
Vue.prototype.$http = axios
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.component('Banner', Banner)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js